import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Package } from "lucide-react";
import { useState, useEffect } from "react";
// project import
import DrawerHeaderStyled from "./DrawerHeaderStyled";
import { defaultColors } from '@/themes/antd-theme';

// ==============================|| DRAWER HEADER ||============================== //

const DrawerHeader = ({ open }) => {
  const { company_logo } = useSelector((state) => state.company_profile);
  const [showContent, setShowContent] = useState(open);
  
  useEffect(() => {
    if (open) {
      // Show content immediately when opening
      setShowContent(true);
    } else {
      // Delay hiding content when closing to sync with drawer
      const timer = setTimeout(() => setShowContent(false), 225);
      return () => clearTimeout(timer);
    }
  }, [open]);
  
  return (
    <DrawerHeaderStyled open={open}>
      <div className="flex flex-row items-center justify-center w-full py-1">
        {showContent ? (
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-teal-400 to-teal-600 rounded-lg flex items-center justify-center shadow-lg">
              <Package size={24} className="text-white" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-white tracking-tight">BatchGenius</h1>
              <p className="text-xs text-teal-200/80 font-medium">Electronic Batch Manufacturing</p>
            </div>
          </div>
        ) : (
          <span className="text-xl font-bold text-white">
            BG
          </span>
        )}
      </div>
    </DrawerHeaderStyled>
  );
};

DrawerHeader.propTypes = {
  open: PropTypes.bool,
};

export default DrawerHeader;